import { UserName } from "../../../Users/shared/UserName.js";
import { LocationName } from "../../../Locations/shared/LocationName.js";
import { REFS_BY_TYPE_LABELS_MAP } from "../constants.js";
import { EventName } from "../../../Events/shared/EventName.js";
import { LocationLogEntryTitle } from "../../../Locations/shared/LocationLogEntries/LocationLogEntryTitle.js";
import { RecordTitle } from "../../../Records/shared/RecordTitle.js";
import { ReportTitle } from "../../../Reports/shared/ReportTitle.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/RefsByTypeTitles/components/RefsVertical.tsx
var typeComponents = {
	eventIds: (id) => /* @__PURE__ */ jsx(EventName, { id }, id),
	locationIds: (id) => /* @__PURE__ */ jsx(LocationName, { locationId: id }, id),
	locationLogEntryIds: (id) => /* @__PURE__ */ jsx(LocationLogEntryTitle, { id }, id),
	recordIds: (id) => /* @__PURE__ */ jsx(RecordTitle, { id }, id),
	reportIds: (id) => /* @__PURE__ */ jsx(ReportTitle, { id }, id),
	userIds: (id) => /* @__PURE__ */ jsx(UserName, { userId: id }, id)
};
function RefsVertical({ refsByType }) {
	return /* @__PURE__ */ jsx("div", {
		className: "gap-y-sm flex flex-col",
		children: Object.entries(refsByType).map(([type, ids]) => !!ids?.length && /* @__PURE__ */ jsxs("div", {
			className: "gap-y-xxs flex flex-col",
			children: [/* @__PURE__ */ jsx(Label, { children: REFS_BY_TYPE_LABELS_MAP[type].plural }), !!ids?.length && ids.map((id) => typeComponents[type](id))]
		}, type))
	});
}
//#endregion
export { RefsVertical };

//# sourceMappingURL=RefsVertical.js.map